<template>
	<div id="idDataCube" ref="idDataCube" style="border:0px solid red;">
		<!--div style="width:1721px; height:866px; border:0px solid red; background:#00456b; display:flex; flex-direction:column;" ref="idScalePan"-->
		<div style="width:1721px; height:866px; border:0px solid red; background:url(/static/aiphoto_images/cube_line2.png); display:flex; flex-direction:column;" ref="idScalePan">
			<div class="CubeTitle" style="flex:0 0 auto; width:100%; height:74px; border:0px solid red;">
				<div style="float:left; width:180px; height:30px; text-align:center; line-height:30px; border:0px solid red; margin-top:10px; color:#ffffff;" ref="idCurDT"></div>
				<div style="float:right; margin-top:10px; margin-right:10px; width:30px; height:30px; border:0px solid red; opacity:0.5; cursor:pointer; background:url(/static/images/icon_lar.png); background-size:100% 100%;" @click="onFullBody" ref="idBtnLarger"></div>
			</div>
			<div style="flex:0 0 auto; width:100%; height:10px; border:0px solid red;"></div>
			<div style="flex:1 0 auto; width:100%; display:flex; flex-direction:row; border:0px solid red;">
				<div style="flex:0 0 auto; height:100%; border:0px solid red; width:10px;"></div>
				<!--左侧-->
				<div style="flex:0 0 auto; height:100%; border:0px solid red; width:420px; display:flex; flex-direction:column;">
					<!-- 客户/资源, 设备统计-->
					<div style="flex:0 0 auto; height:150px; border:0px solid blue; display:flex; flex-direction:row;">
						<div style="flex:0 0 auto; width:200px; border:1px solid #f1f1f1;">
							<div class="DataTitle" ref="idTitle11"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;" ref="idDataCapt11"></div>
							<div class="DataCont" style="margin-top:8px; width:60px;  height:30px; line-height:30px;" ref="idCustItem1"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;" ref="idDataCapt12"></div>
							<div class="DataCont" style="margin-top:8px; width:60px;  height:30px; line-height:30px;" ref="idCustItem2"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;" ref="idDataCapt13"></div>
							<div class="DataCont" style="margin-top:8px; width:60px;  height:30px; line-height:30px;" ref="idCustItem3"></div>
						</div>
						<div style="flex:0 0 auto; width:200px; border:1px solid #f1f1f1; margin-left:10px;">
							<div class="DataTitle" ref="idTitle12"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;" ref="idDataCapt23"></div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idDevItem3"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;" ref="idDataCapt22"></div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idDevItem2"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;" ref="idDataCapt21"></div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idDevItem1"></div>
						</div>
					</div>
					<!-- 设备预警 -->
					<div style="flex:0 0 auto; height:150px; border:0px solid blue; display:flex; flex-direction:row;">
						<div style="flex:0 0 auto; width:200px; border:1px solid #f1f1f1;">
							<div class="DataTitle">{{getLangText("设备到期预警")}}</div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;">{{getLangText("已过期")}}</div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idWarn1"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;">{{getLangText("近7日将过期")}}</div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idWarn2"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;">{{getLangText("近30日将过期")}}</div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idWarn3"></div>
						</div>
						<div style="flex:0 0 auto; width:200px; border:1px solid #f1f1f1; margin-left:10px;">
							<div class="DataTitle">{{getLangText("设备状态")}}</div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;">{{getLangText("正式")}}</div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idAuth1"></div>

							<div class="DataCapt" style="margin-top:8px; width:130px; height:30px; line-height:30px;">{{getLangText("试用")}}</div>
							<div class="DataCont" style="margin-top:8px; width:60px; height:30px; line-height:30px;" ref="idAuth2"></div>
						</div>
					</div>

					<!-- 设备活跃度 -->
					<div style="flex:0 0 auto; width:410px; height:180px; margin-top:20px; border:1px solid #f1f1f1;">
						<div class="DataTitle" style="width:408px">{{getLangText("设备活跃度")}}</div>
						<div style="width:410px; height:140px; float:left; " ref="idDevActive"></div>
					</div>

					<!-- 历史收益 -->
					<div style="flex:0 0 auto; width:410px; height:250px; margin-top:20px; border:1px solid #f1f1f1;">
						<div class="DataTitle" style="width:408px" ref="idHisCapt"></div>
						<div style="float:left; width:100%; height:200px; margin-top:10px; border:0px solid red;" ref="idHisMoney"></div>
					</div>


				</div>

				<!--中间地图、拍照记录-->
				<div style="flex:0 0 auto; width:961px; height:770px; border:1px solid #f1f1f1; display:flex; flex-direction:column;">
					<div style="flex:1 0 auto; border:0px solid red;  height:600px;" ref="idWorldMap"></div>
					<div style="flex:1 0 auto; border-top:1px solid #f1f1f1; height:170px;" ref="idRecordPan">
						<table ref="idMsgPanel" style="width:100%;"></table>
					</div>
				</div>

				<!--右侧-->
				<div style="flex:0 0 auto; height:100%; border:0px solid red; width:310px; margin-left:10px; display:flex; flex-direction:column;">
					<div style="flex:0 0 auto; width:310px; height:180px; border:1px solid #f1f1f1; ">
						<div class="DataTitle" style="width:308px;">{{ getLangText("今日设备排行") }}</div>
						<div style="float:left; width:100%; height:22px; line-height:22px; text-align:center; color:#ffffff;" ref="idDevUsedAll">{{getLangText("今日")+": "}}</div>
						<div class="ItemLine" style="margin-top:-3px;"><div class="ItemGrid" style="width:50%;">device</div><div class="ItemGrid" style="width:30%;" >used</div><div class="ItemGrid" style="width:20%;" >rate</div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idDev.ID1"></div><div class="ItemGrid" style="width:30%;" ref="idDev.CNT1"></div><div class="ItemGrid" style="width:20%;" ref="idDev.RA1"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idDev.ID2"></div><div class="ItemGrid" style="width:30%;" ref="idDev.CNT2"></div><div class="ItemGrid" style="width:20%;" ref="idDev.RA2"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idDev.ID3"></div><div class="ItemGrid" style="width:30%;" ref="idDev.CNT3"></div><div class="ItemGrid" style="width:20%;" ref="idDev.RA3"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idDev.ID4"></div><div class="ItemGrid" style="width:30%;" ref="idDev.CNT4"></div><div class="ItemGrid" style="width:20%;" ref="idDev.RA4"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idDev.ID5"></div><div class="ItemGrid" style="width:30%;" ref="idDev.CNT5"></div><div class="ItemGrid" style="width:20%;" ref="idDev.RA5"></div></div>
					</div>

					<div style="flex:0 0 auto; width:310px; height:180px; border:1px solid #f1f1f1; margin-top:16px;">
						<div class="DataTitle" style="width:308px;">{{ getLangText("今日模板排行") }}</div>
						<div style="float:left; width:100%; height:22px; line-height:22px; margin-top:0px; text-align:center; color:#ffffff;" ref="idTempUsedAll">{{getLangText("今日")+": "}}</div>
						<div class="ItemLine" style="margin-top:-3px;"><div class="ItemGrid" style="width:50%;">material</div><div class="ItemGrid" style="width:30%;" >used</div><div class="ItemGrid" style="width:20%;" >rate</div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idTemp.ID1"></div><div class="ItemGrid" style="width:30%;" ref="idTemp.CNT1"></div><div class="ItemGrid" style="width:20%;" ref="idTemp.RA1"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idTemp.ID2"></div><div class="ItemGrid" style="width:30%;" ref="idTemp.CNT2"></div><div class="ItemGrid" style="width:20%;" ref="idTemp.RA2"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idTemp.ID3"></div><div class="ItemGrid" style="width:30%;" ref="idTemp.CNT3"></div><div class="ItemGrid" style="width:20%;" ref="idTemp.RA3"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idTemp.ID4"></div><div class="ItemGrid" style="width:30%;" ref="idTemp.CNT4"></div><div class="ItemGrid" style="width:20%;" ref="idTemp.RA4"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idTemp.ID5"></div><div class="ItemGrid" style="width:30%;" ref="idTemp.CNT5"></div><div class="ItemGrid" style="width:20%;" ref="idTemp.RA5"></div></div>
					</div>

					<div style="flex:0 0 auto; width:310px; height:180px; border:1px solid #f1f1f1; margin-top:16px;">
						<div class="DataTitle" style="width:308px;">{{ getLangText("历史模板排行") }}</div>
						<div style="float:left; width:100%; height:22px; line-height:22px; margin-top:0px; text-align:center; color:#ffffff;" ref="idHTmpAll">{{getLangText("所有")+": "}}</div>
						<div class="ItemLine" style="margin-top:-3px;"><div class="ItemGrid" style="width:50%;">template</div><div class="ItemGrid" style="width:30%;" >used</div><div class="ItemGrid" style="width:20%;" >rate</div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idHTmp.ID1"></div><div class="ItemGrid" style="width:30%;" ref="idHTmp.CNT1"></div><div class="ItemGrid" style="width:20%;" ref="idHTmp.RA1"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idHTmp.ID2"></div><div class="ItemGrid" style="width:30%;" ref="idHTmp.CNT2"></div><div class="ItemGrid" style="width:20%;" ref="idHTmp.RA2"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idHTmp.ID3"></div><div class="ItemGrid" style="width:30%;" ref="idHTmp.CNT3"></div><div class="ItemGrid" style="width:20%;" ref="idHTmp.RA3"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idHTmp.ID4"></div><div class="ItemGrid" style="width:30%;" ref="idHTmp.CNT4"></div><div class="ItemGrid" style="width:20%;" ref="idHTmp.RA4"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idHTmp.ID5"></div><div class="ItemGrid" style="width:30%;" ref="idHTmp.CNT5"></div><div class="ItemGrid" style="width:20%;" ref="idHTmp.RA5"></div></div>
					</div>

					<div style="flex:0 0 auto; width:310px; height:180px; border:1px solid #f1f1f1; margin-top:16px;">
						<div class="DataTitle" style="width:308px;">{{ getLangText("历史素材排行") }}</div>
						<div style="float:left; width:100%; height:22px; line-height:22px; margin-top:0px; text-align:center; color:#ffffff;" ref="idSorcAll">{{getLangText("所有")+": "}}</div>
						<div class="ItemLine" style="margin-top:-3px;"><div class="ItemGrid" style="width:50%;">material</div><div class="ItemGrid" style="width:30%;" >used</div><div class="ItemGrid" style="width:20%;" >rate</div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idSorc.ID1"></div><div class="ItemGrid" style="width:30%;" ref="idSorc.CNT1"></div><div class="ItemGrid" style="width:20%;" ref="idSorc.RA1"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idSorc.ID2"></div><div class="ItemGrid" style="width:30%;" ref="idSorc.CNT2"></div><div class="ItemGrid" style="width:20%;" ref="idSorc.RA2"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idSorc.ID3"></div><div class="ItemGrid" style="width:30%;" ref="idSorc.CNT3"></div><div class="ItemGrid" style="width:20%;" ref="idSorc.RA3"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idSorc.ID4"></div><div class="ItemGrid" style="width:30%;" ref="idSorc.CNT4"></div><div class="ItemGrid" style="width:20%;" ref="idSorc.RA4"></div></div>
						<div class="ItemLine" style="margin-top:0px;"><div class="ItemGrid" style="width:50%;" ref="idSorc.ID5"></div><div class="ItemGrid" style="width:30%;" ref="idSorc.CNT5"></div><div class="ItemGrid" style="width:20%;" ref="idSorc.RA5"></div></div>
					</div>
				</div>
				<div style="flex:0 0 auto; height:100%; border:0px solid red; width:10px;"></div>
			</div>
		</div>
	</div>
</template>

<script>

import world from './world.json'

export default {
	name: 'DataCube',
	components:{

	},
	data () {
		return {
			isFullScreen: false,

			oriWidth: 1721,       // 设计的标准大小
			oriHeight: 866,       // 设计的标准大小

			lineCnt: 0,           // 消息的行数
			myWorld: null,
			myChartHisMoney: null,
			myChartDevActive: null,
			cpId: null,
		}
	},
	mounted: function(){
		this.$echarts.registerMap("world", world );
		this.myWorld = this.$echarts.init(this.$refs["idWorldMap"]);
		this.myChartHisMoney = this.$echarts.init(this.$refs["idHisMoney"]);
		this.myChartDevActive = this.$echarts.init(this.$refs["idDevActive"]);

		this.CustomerDisp( 0, 0, 0);         // 初始显示客户数
		this.DeviceDisp( 0, 0, 0 );          // 初始显示设备数
		this.WarnDisp( 0, 0, 0 );            // 初始显示设备预警数
		this.deviceAuthType( [{value:0, name:LangText("正式")},{value:0, name:LangText("试用")}] );
		this.showDevActive( [{ value: 80, name: 'today ' }, { value: 60, name: '7 days ' }, { value: 40, name: '30 days ' }, { value: 20, name: 'other ' }] );
		this.showHisMoney( ['', '', '', '', '', ''], [0,0,0,0,0,0], [0,0,0,0,0,0], [0,0,0,0,0,0] );
		this.showWorldMap( [ {name: "", value: [0, 0, 0]} ] );

		this.onResize();

		this.login.curMenu = "/FrameBody/DataCube";

		setTimeout( this.getSumData1, 50 );
		setTimeout( this.getSumData2, 100 );
		setTimeout( this.getSumData3, 200 );
		setTimeout( this.getSumData4, 300 );
		setTimeout( this.getSumData5, 400 );

		setTimeout( this.getDatetime, 110 );         // 时间定时
	},
	computed:{

	},
	methods:{
		toggleFullScreen(){
			this.isFullScreen = !this.isFullScreen;

			const el = this.$refs["idDataCube"];
			if( this.isFullScreen )
			{
				el.requestFullscreen();
			}
			else
			{
				document.exitFullscreen();
			}
		},

		/* 定时更新时间 */
		getDatetime: function(){
			if( !this.$refs["idCurDT"] ) return;

			let s = this.getDTStr( 1, 1, 0, 0);
			this.$refs["idCurDT"].innerText = s;
			setTimeout( this.getDatetime, 200 );
		},
		onResize: function(){
			this.$refs["idDataCube"].style["transform"] = "scale("+(this.$refs["idDataCube"].offsetWidth/this.oriWidth)+","+ (this.$refs["idDataCube"].offsetHeight/this.oriHeight)+")";
			this.$refs["idDataCube"].style["transform-origin"] = "0 0";
		},
		/* 全窗口显示 */
		onFullBody: function(){
			this.fullBodyFlag = !this.fullBodyFlag;
			this.$parent.$parent.fullBody( this.fullBodyFlag, "#00456b" );
			this.$parent.fullBody( this.fullBodyFlag, "#00456b" );
			this.$parent.onResize();
			if( this.fullBodyFlag )
				 this.$refs["idBtnLarger"].style["background"] = "url(/static/images/icon_lit.png)";
			else this.$refs["idBtnLarger"].style["background"] = "url(/static/images/icon_lar.png)";
			this.$refs["idBtnLarger"].style["background-size"] = "100% 100%";
		},
		/* 汇总数据获取 */
	    getSumData1: function(){
	    	if( this.login.curMenu != "/FrameBody/DataCube" ) return;
	    	this.doTrade( "POST", ServAddr+"/api/sum/sumCube1", this.dosumCube1, false, null, null );
	    },
	    dosumCube1: function( res ){
	    	this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == "200" )
			{
				if( this.login.custId == gPlatCustId )
					 this.CustomerDisp( data.body.custCnt, data.body.custCnt7, data.body.custCnt30 );
				else this.CustomerDisp( data.body.siCnt, data.body.templateCnt, data.body.phCnt );

				this.DeviceDisp( data.body.devCnt, data.body.devCnt7, data.body.devCnt30 );
				this.WarnDisp( data.body.warnCnt, data.body.warnCnt7, data.body.warnCnt30 );
				let n1=data.body.formalCnt;  if( n1==null ) n1 = 0;
				let n2=data.body.tryCnt;     if( n2==null ) n2 = 0;
				this.deviceAuthType( [{value:n1, name:LangText("正式")},{value:n2, name:LangText("试用")}] );

				let k1=data.body.actCnt1;   if( k1==null ) k1 = 0;
				let k2=data.body.actCnt7;   if( k2==null ) k2 = 0;
				let k3=data.body.actCnt30;  if( k3==null ) k3 = 0;
				let cntx=data.body.devCnt - k1 - k2 - k3;
				this.showDevActive( [{ value: 80, name: 'today [ '+k1+" ]" }, { value: 60, name: '7 days [ '+k2+" ]" }, { value: 40, name: '30 days [ '+k3+" ]" }, { value: 20, name: 'other [ '+cntx+" ]" }] );
			}
			setTimeout( this.getSumData1, 10*60*1000 );
	    },
	     getSumData2: function(){
	     	if( this.login.curMenu != "/FrameBody/DataCube" ) return;
	    	this.doTrade( "POST", ServAddr+"/api/sum/sumCube2", this.dosumCube2, false, null, null );
	    },
		dosumCube2: function( res ){
			this.appRoot.app.closeDlgRun();
			if( !this.$refs["idHisCapt"] ) return;

			let data=res.body;
			if( data.code == "200" )
			{
				let feeNor=data.body.feeNor.split(",");
				let feeVip=data.body.feeVip.split(",");
				let feeSVip=data.body.feeSVip.split(",");
				for( let i=0; i<6; i++ )
				{
					if( this.login.custId == gPlatCustId )  // 近6个月收益统计-平台
					{
						this.$refs["idHisCapt"].innerText = LangText("收益历史");

						feeNor[i] = parseInt( feeNor[i]/100);
						feeVip[i] = parseInt( feeVip[i]/100);
						feeSVip[i] = parseInt( feeSVip[i]/100);
					}
					else  // 近6个月拍照数-客户
					{
						this.$refs["idHisCapt"].innerText = LangText("月拍照数");

						feeNor[i] = parseInt( feeNor[i]);
						feeVip[i] = parseInt( feeVip[i]);
						feeSVip[i] = parseInt( feeSVip[i]);
					}
				}


				this.showHisMoney( data.body.feeMonths.split(","), feeNor, feeVip, feeSVip );
			}
			setTimeout( this.getSumData2, 10*60*1000 );
		},
		getSumData4: function(){
			if( this.login.curMenu != "/FrameBody/DataCube" ) return;
			this.doTrade( "POST", ServAddr+"/api/sum/sumCube4", this.dosumCube4, false, null, null );
		},
		dosumCube4: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == "200" )
			{
				let arr=[];
				for( let i=0; i<data.body.distList.length; i++ )
				{
					let item=data.body.distList[i];
					arr.push( {name:item.distName, value: [item.distLocate.split(",")[0] , item.distLocate.split(",")[1], item.distVal] } );
				}
				this.showWorldMap( arr );
			}
			setTimeout( this.getSumData4, 10*60*1000 );
		},
		getSumData5: function(){
			if( this.login.curMenu != "/FrameBody/DataCube" ) return;
			let body={cpDate: parseInt(this.getDTStr(2, 0, 0, 0)) };
			this.doTrade( "POST", ServAddr+"/api/sum/sumCube5", this.dosumCube5, false, body, null );
		},
		dosumCube5: function( res ){
			this.appRoot.app.closeDlgRun();
			if( !this.$refs["idDevUsedAll"] ) return;

			let data=res.body;
			if( data.code == "200" )
			{
				for( let i=0; i<5; i++ )
				{
					this.$refs["idDev.ID"+ (i+1)].innerText = "";
					this.$refs["idDev.CNT"+(i+1)].innerText = "";
					this.$refs["idDev.RA"+ (i+1)].innerText = "";

					this.$refs["idTemp.ID"+ (i+1)].innerText = "";
					this.$refs["idTemp.CNT"+(i+1)].innerText = "";
					this.$refs["idTemp.RA"+ (i+1)].innerText = "";

					this.$refs["idHTmp.ID"+ (i+1)].innerText = "";
					this.$refs["idHTmp.CNT"+(i+1)].innerText = "";
					this.$refs["idHTmp.RA"+ (i+1)].innerText = "";

					this.$refs["idSorc.ID"+ (i+1)].innerText = "";
					this.$refs["idSorc.CNT"+(i+1)].innerText = "";
					this.$refs["idSorc.RA"+ (i+1)].innerText = "";
				}

				// 设备今日排行
				this.$refs["idDevUsedAll"].innerText = LangText("今日")+": "+data.body.todayDevTimesAll;
				for( let i=0; i<data.body.todayDevTop5.length; i++ )
				{
					this.$refs["idDev.ID"+ (i+1)].innerText = data.body.todayDevTop5[i].devId;
					this.$refs["idDev.CNT"+(i+1)].innerText = data.body.todayDevTop5[i].usedTimes;
					if( data.body.todayDevTimesAll == 0 )
						 this.$refs["idDev.RA"+ (i+1)].innerText = "";
					else this.$refs["idDev.RA"+ (i+1)].innerText = parseInt(data.body.todayDevTop5[i].usedTimes*100/data.body.todayDevTimesAll)+"%";
				}

				// 模板今日排行
				this.$refs["idTempUsedAll"].innerText = LangText("今日")+": "+data.body.todayTempTimesAll;
				for( let i=0; i<data.body.todayTempTop5.length; i++ )
				{
					this.$refs["idTemp.ID"+ (i+1)].innerText = data.body.todayTempTop5[i].templateId;
					this.$refs["idTemp.CNT"+(i+1)].innerText = data.body.todayTempTop5[i].usedTimes;
					if( data.body.todayTempTimesAll == 0 )
						 this.$refs["idTemp.RA"+ (i+1)].innerText = "";
					else this.$refs["idTemp.RA"+ (i+1)].innerText = parseInt(data.body.todayTempTop5[i].usedTimes*100/data.body.todayTempTimesAll)+"%";
				}

				// 模板历史排行
				this.$refs["idHTmpAll"].innerText = LangText("所有")+": "+data.body.hisTempTimesAll;
				for( let i=0; i<data.body.hisTempTop5.length; i++ )
				{
					this.$refs["idHTmp.ID"+ (i+1)].innerText = data.body.hisTempTop5[i].templateId;
					this.$refs["idHTmp.CNT"+(i+1)].innerText = data.body.hisTempTop5[i].usedTimes;
					if( data.body.hisTempTimesAll == 0 )
						 this.$refs["idHTmp.RA"+ (i+1)].innerText = "";
					else this.$refs["idHTmp.RA"+ (i+1)].innerText = parseInt(data.body.hisTempTop5[i].usedTimes*100/data.body.hisTempTimesAll)+"%";
				}

				// 素材历史排行
				this.$refs["idSorcAll"].innerText = LangText("所有")+": "+data.body.hisSourceTimesAll;
				for( let i=0; i<data.body.hisSourceTop5.length; i++ )
				{
					this.$refs["idSorc.ID"+ (i+1)].innerText = data.body.hisSourceTop5[i].siId;
					this.$refs["idSorc.CNT"+(i+1)].innerText = data.body.hisSourceTop5[i].usedTimes;
					if( data.body.hisSourceTimesAll == 0 )
						 this.$refs["idSorc.RA"+ (i+1)].innerText = "";
					else this.$refs["idSorc.RA"+ (i+1)].innerText = parseInt(data.body.hisSourceTop5[i].usedTimes*100/data.body.hisSourceTimesAll)+"%";
				}
			}
			setTimeout( this.getSumData5, 1*60*1000 );
		},
		/* 用户统计 */
		CustomerDisp: function( n1, n2, n3 ){
			if( !this.$refs["idTitle11"] ) return;
			if( n1 == null ) n1 = 0;
			if( n2 == null ) n2 = 0;
			if( n3 == null ) n3 = 0;

			if( this.login.custId == gPlatCustId )
			{
				this.$refs["idTitle11"].innerText = LangText("客户");

				this.$refs["idDataCapt11"].innerText = LangText("客户数");
				this.$refs["idDataCapt12"].innerText = LangText("近7日新增");
				this.$refs["idDataCapt13"].innerText = LangText("近30日新增");

				this.$refs["idCustItem1"].innerHTML = n1;    // 客户总数
				this.$refs["idCustItem2"].innerHTML = n2;    // 7日新增客户
				this.$refs["idCustItem3"].innerHTML = n3;    // 30日新增客户
			}
			else
			{
				this.$refs["idTitle11"].innerText = LangText("资源");

				this.$refs["idDataCapt11"].innerText = LangText("素材");
				this.$refs["idDataCapt12"].innerText = LangText("模板");
				this.$refs["idDataCapt13"].innerText = LangText("拍照");

				this.$refs["idCustItem1"].innerHTML = n1;    // 素材
				this.$refs["idCustItem2"].innerHTML = n2;    // 模板
				this.$refs["idCustItem3"].innerHTML = n3;    // 拍照次数
			}
		},
		/* 设备统计 */
		DeviceDisp: function( n1, n2, n3 ){
			if( !this.$refs["idTitle12"] ) return;
			if( n1 == null ) n1 = 0;
			if( n2 == null ) n2 = 0;
			if( n3 == null ) n3 = 0;

			this.$refs["idTitle12"].innerText = LangText("设备");

			this.$refs["idDataCapt23"].innerText = LangText("设备数");
			this.$refs["idDataCapt22"].innerText = LangText("近7日新增");
			this.$refs["idDataCapt21"].innerText = LangText("近30日新增");

			this.$refs["idDevItem3"].innerHTML = n1;     // 设备总数
			this.$refs["idDevItem2"].innerHTML = n2;     // 7日新增设备
			this.$refs["idDevItem1"].innerHTML = n3;     // 30日新增设备
		},
		/* 设备到期预警 */
		WarnDisp: function( n1, n2, n3 ){
			if( !this.$refs["idWarn1"] ) return;
			if( n1 == null ) n1 = 0;
			if( n2 == null ) n2 = 0;
			if( n3 == null ) n3 = 0;

			this.$refs["idWarn1"].innerText = n1;
			this.$refs["idWarn2"].innerText = n2;
			this.$refs["idWarn3"].innerText = n3;
		},
		/* 设备状态统计 */
		deviceAuthType: function( authData ){
			if( !this.$refs["idAuth1"] ) return;

			this.$refs["idAuth1"].innerText = authData[0].value;
			this.$refs["idAuth2"].innerText = authData[1].value;
	    },
		/* 设备活跃度 */
		showDevActive: function( actData ){
			if( !this.$refs["idDevActive"] ) return;

			const option = {
				series: [
					{
						type: 'funnel',
						left: 40,
						right: 10,
						top: 10,
						bottom: 10,
						width: '50%',
						sort: 'descending',    // 排序方式
						gap: 10,               // 间距
						label: {
							formatter: '{b}',
							fontSize: 16,
							color:'#ffffff',
			            },
						color: ['#ec1735', '#da25cf', '#da8725', '#765b3a'],
						data: actData
					}
				]
			};

			this.myChartDevActive.setOption(option);
		},
		/* 历史收益 */
		showHisMoney: function( pXLabel, pNorFee, pVipFee, pSVipFee ){
			if( !this.$refs["idHisMoney"] ) return;

			const option = {
				grid:{
					show: true,
					top:10,
					height: 160,
					width:350,
					borderWidth:0,    // 去掉外层边框
				},
				color:[ "#1eca15", "#2222e7", "#e3af42" ],
				xAxis: {
					type: 'category',
					data: pXLabel,
					axisLabel: { color: '#ffffff' },    // x轴 刻度颜色
				},
				yAxis: {
					type: 'value',
					splitLine: {       // 显示虚线
                        show: true,
                        lineStyle:{
                            color: ['#729ac3'],
                            width: 1,
                            type: 'dashed'
                        }
                　　},
                	axisLabel: { color: '#ffffff' },    // Y轴 刻度颜色
				},
				series: [
				    /*{ type: 'bar', data: pNorFee,
				    	itemStyle: {
				            borderRadius: [10, 10, 0, 0],   // 设置柱状图顶部为圆形
				            // 设置渐变色
				            color: {
				                type: 'linear',
				                x: 0,
				                y: 0,
				                x2: 0,
				                y2: 1,
				                colorStops: [
				                    {offset: 0, color: '#1eca15'}, // 0% 处的颜色
				                    {offset: 1, color: '#1d65d4'} // 100% 处的颜色
				                ],
				                global: false // 缺省为 false
				            }
				        }
				    },
					{ type: 'bar', data: pVipFee,
				    	itemStyle: {
				            borderRadius: [10, 10, 0, 0],   // 设置柱状图顶部为圆形
				            // 设置渐变色
				            color: {
				                type: 'linear',
				                x: 0,
				                y: 0,
				                x2: 0,
				                y2: 1,
				                colorStops: [
				                    {offset: 0, color: '#e3af42'}, // 0% 处的颜色
				                    {offset: 1, color: '#1d65d4'} // 100% 处的颜色
				                ],
				                global: false // 缺省为 false
				            }
				        }
				    },*/
					{ type: 'bar', data: pSVipFee, barWidth: '40%',
				    	itemStyle: {
				            borderRadius: [10, 10, 0, 0],   // 设置柱状图顶部为圆形
				            // 设置渐变色
				            color: {
				                type: 'linear',
				                x: 0,
				                y: 0,
				                x2: 0,
				                y2: 1,
				                colorStops: [
				                    {offset: 0, color: '#ffffff'}, // 100% 处的颜色
				                    {offset: 1, color: '#0001ff'} // 0% 处的颜色
				                ],
				                global: false // 缺省为 false
				            }
				        }
				    },
				]
			};

			this.myChartHisMoney.setOption(option);
		},
		/* 客户或者设备分布 */
		showWorldMap: function( pDistData ){
			let option={
				geo: {
					map: 'world',
					roam: false,
					zoom: 1.2,         // 缩放比例
					label: {
						normal:   { show: false, textStyle: { color: '#02F6F9' } },  // 正常时 区块的名称
						emphasis: { show: true,  textStyle: { color: '#ed174f' } }   // hover时区块的名称
					},
					itemStyle: {
						normal:   { borderWidth: 1, areaColor: '#ffffff', borderColor: '#c1c1c1' },  // 正常时 区块和边框的颜色
						emphasis: { borderWidth: 1, areaColor: '#5f5fdf', borderColor: '#5f5fdf' }   // hover时区块和边框的颜色
					}
				},
				series: [
					{
						type: 'scatter',
						coordinateSystem: 'geo',
						label: {                            // 散热点标签属性设置
							normal:   { show: false },
							emphasis: { show: false }
						},
						itemStyle: {                        //散热点hover时的样式
							normal: { color: '#e04557' }
						},
						symbol: 'circle',
						symbolSize: function(val) {
							let scale=2;
							return (val[2]+1)*scale;
							//	 if( val[2] < 5  ) return 1*scale;
							//else if( val[2] < 10 ) return 2*scale;
							//else if( val[2] < 15 ) return 3*scale;
						},
						data: pDistData,
					}
				]
			};

			this.myWorld.setOption(option);
		},
		getSumData3: function(){
			if( this.login.curMenu != "/FrameBody/DataCube" ) return;
			this.doTrade( "POST", ServAddr+"/api/sum/sumCube3", this.dosumCube3, false, {cpId:this.cpId}, null );
		},
		dosumCube3: function( res ){
			this.appRoot.app.closeDlgRun();
			if( !this.$refs["idMsgPanel"] ) return;

			let data=res.body;
			if( data.code == "200" && 0<data.body.allCnt )
			{
				let table=this.$refs["idMsgPanel"];
				let rowCount=table.rows.length;
				let h1=this.$refs["idRecordPan"].offsetHeight;
				let h2=table.offsetHeight;
				if( (h1-10 ) < h2 )
				{
					table.deleteRow(rowCount - 1);
					let h2=table.offsetHeight;
				}

				let times=data.body.cpDownTimes;
				if( times < 0 ) times = 0;
				let tr=table.insertRow( 0 );
				let tdStyle="white-space:nowrap; padding-left:6px; padding-right:6px; text-align:center;";
				tr.style["height"] = "30px";
				//tr.style["background"] = "#f5f5f5";
				tr.style["color"] = "#ffffff";
				tr.innerHTML = 	"<td style='width:180px; "+tdStyle+"'>"+data.body.cpAddDatetime.substring(0, 19)+"</td>"+
								"<td style='width:110px; "+tdStyle+"'>"+this.splitYMD(data.body.cpValidate,1)+"</td>"+
								"<td style='width:40px; "+tdStyle+"'>"+times+"</td>"+
								"<td style='width:110px; "+tdStyle+"'>"+data.body.cpDeviceCustId+"</td>"+
								"<td style='width:110px; "+tdStyle+"'>"+data.body.cpDeviceId+"</td>"+
								"<td style='width:80px; "+tdStyle+"'>"+data.body.cpShareMode+"</td>"+
								"<td style='width:110px; "+tdStyle+"'>"+data.body.cpTemplateId+"</td>"+
								"<td style='"+tdStyle+"'>"+data.body.cpOrderno+"</td>";
				this.cpId = data.body.cpId;
			}

			if( ( data.hasOwnProperty("body") ) && (data.body!=null) && (data.body.allCnt > 0) )
				 setTimeout( this.getSumData3, 3*1000 );
			else setTimeout( this.getSumData3, 60*1000 );
		},
	}
}

</script>

<style scoped>

#idDataCube{ width:100%; height:100%; }

.CubeTitle{ background:url(../../static/aiphoto_images/cube_title.png); background-size:100% 100%; }
.DataTitle{ float:left; width:100%; height:30px; line-height:30px; text-indent:10px; font-weight:bold; background:url(/static/aiphoto_images/cube_data_title.png); background-size:100% 100%; color:#ffffff; text-align:left; font-size:16px; }
.DataCapt{ float:left; color:#ffffff; text-align:right; border:0px solid red; font-size:14px; }
.DataCont{ float:left; color:#ffffff; text-align:left; border:0px solid red; text-indent:10px; }

/*.CubeTitle{ background:url(../../static/images/cube_title.png); border:0px solid red; text-align:center; color:#2a83cf; font-size:28px; }*/
.ItemLine{ float:left; width:100%; border:0px solid red;  }
.ItemLine .LineCapt{height:30px; line-height:30px; border:0px solid red; float:left; color:#ffffff; text-align:right; }
.ItemLine .LineCont{height:30px; line-height:30px; border:0px solid red; float:left; color:#ffffff;}
.ItemGrid{  height:20px; line-height:20px; border:0px solid red; float:left; color:#ffffff; text-align:center; }
.MsgPanel{ border:0px solid red; }
.MsgPanel td{ white-space: nowrap; background:#f1f1f1; }

.HeadDataItemL{ float:left; width:30%; height:53px; line-height:53px; color:#2a83cf;  white-space: nowrap; text-indent:10px; border:0px solid red; }
.HeadDataItemR{ float:right; width:30%; height:53px; line-height:53px; color:#2a83cf; white-space: nowrap; text-indent:10px; border:0px solid red; text-align:right; padding-right:10px;}

</style>



// WEBPACK FOOTER //
// DataCube.vue?61fd7c10